export default "__VITE_ASSET__DBtga7Wt__"